var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommitteSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35.797,
    height: 34.625,
    viewBox: "0 0 35.797 34.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4adede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6172d6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2453",
    "data-name": "Group 2453",
    transform: "translate(-0.099 3.883)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    d: "M29.116,20.21a13.91,13.91,0,0,1,5.17-.035c1.51.306,2.546,1.952,2.6,3.786.01.482.01.964.01,1.446-.01.541-.168.729-.631.729H30.1c.257,1.517.5,2.986.75,4.468l.3,1.764c.109.6-.089.894-.6.894H23.985V34.93c0,.788-.148.952-.8.952H14.8c-.631,0-.78-.176-.78-.929V33.261H7.546c-.632,0-.8-.247-.681-.964.345-2.034.681-4.068,1.036-6.161H1.8c-.553,0-.7-.165-.7-.835a13.221,13.221,0,0,1,.049-1.881,3.655,3.655,0,0,1,3.158-3.374c1.145-.071,2.289-.035,3.434-.012a9.059,9.059,0,0,1,1.164.2c.138-.788.276-1.6.414-2.41q.533-3.122,1.046-6.243c.079-.482.257-.647.7-.647h2.516c.059-.271.1-.517.158-.752a3.816,3.816,0,0,1,3.414-3.233q1.865-.053,3.73,0a3.885,3.885,0,0,1,3.414,3.5c.059.376.168.506.493.494.7-.035,1.4-.012,2.1-.012.5,0,.641.153.74.741.474,2.786.937,5.561,1.411,8.347C29.076,20.093,29.1,20.163,29.116,20.21Zm-.079,5.926h-1.5c-.4,0-.592-.212-.6-.694-.01-.458-.01-.905,0-1.364a4.639,4.639,0,0,1,1.056-2.916.725.725,0,0,0,.118-.482c-.326-2-.661-3.986-1-5.984-.138-.835-.286-1.681-.434-2.516H11.355c-.02.106-.049.188-.059.27-.464,2.763-.937,5.538-1.391,8.3a.6.6,0,0,0,.128.4A3.906,3.906,0,0,1,10.98,23.2a20.1,20.1,0,0,1,.1,2.316.534.534,0,0,1-.553.611H8.986c-.336,1.987-.661,3.915-1,5.867.089.012.148.035.207.035,1.983,0,3.967.012,5.95-.012a.505.505,0,0,0,.355-.259,3.387,3.387,0,0,1,3.01-2.01q1.495-.018,2.99,0a3.3,3.3,0,0,1,2.98,1.987.456.456,0,0,0,.464.306c1.9-.012,3.819-.012,5.723-.012.109,0,.217-.012.365-.024C29.708,30.051,29.372,28.123,29.037,26.136Zm-6.1,8.5v-.705c-.02-1.587-.839-2.8-2.171-2.916a18.774,18.774,0,0,0-3.542,0c-1.529.153-2.457,1.822-2.112,3.621ZM2.188,24.866h7.864c-.02-.435-.02-.846-.059-1.258A2.537,2.537,0,0,0,7.931,21.28c-1.224-.047-2.457-.012-3.69-.012a.985.985,0,0,0-.257.047C2.671,21.739,1.991,23.079,2.188,24.866Zm33.667.024v-.741c-.02-1.646-1.006-2.869-2.388-2.892-1.056-.023-2.112-.023-3.177,0-1.549.047-2.644,1.8-2.269,3.621C30.616,24.889,33.211,24.889,35.855,24.889ZM23.294,10.91c0-1.117-.849-2.492-1.885-2.6a23.443,23.443,0,0,0-4.805,0c-1.036.106-1.895,1.493-1.875,2.6Z",
    transform: "translate(-0.995 -5.14)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    d: "M25.368,3.586a3.37,3.37,0,1,1-6.737-.012,3.37,3.37,0,1,1,6.737.012Zm-1.209-.035a2.166,2.166,0,1,0-4.33.047,2.166,2.166,0,1,0,4.33-.047Z",
    transform: "translate(-3.988 -4.012)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M6.908,20.445A3.3,3.3,0,0,1,3.672,17.13,3.351,3.351,0,0,1,4.6,14.767a3.22,3.22,0,0,1,4.641.024,3.332,3.332,0,0,1-2.338,5.655Zm.023-5.185a1.8,1.8,0,0,0-1.82,1.846,1.821,1.821,0,0,0,1.82,1.858,1.785,1.785,0,0,0,1.29-.553,1.877,1.877,0,0,0,.53-1.329A1.843,1.843,0,0,0,6.931,15.26Z",
    transform: "translate(-1.995 -4.184)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    d: "M40.2,17.142a3.144,3.144,0,1,1-3.075-3.221A3.127,3.127,0,0,1,40.2,17.142Zm-3.109-2a1.964,1.964,0,1,0,1.9,1.94A1.915,1.915,0,0,0,37.092,15.143Z",
    transform: "translate(-5.977 -4.424)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    d: "M21.983,30.169a3.2,3.2,0,0,1-2.3-.976,3.341,3.341,0,0,1,2.28-5.679h.046a3.332,3.332,0,0,1,3.248,3.316,3.279,3.279,0,0,1-3.259,3.339ZM21.994,25a1.836,1.836,0,0,0-1.808,1.869,1.787,1.787,0,0,0,1.82,1.834h.011a1.722,1.722,0,0,0,1.267-.541,1.925,1.925,0,0,0,.518-1.34A1.823,1.823,0,0,0,22.006,25Z",
    transform: "translate(-3.986 -4.12)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    "data-name": "Path 929",
    d: "M22.006,30.051a3.169,3.169,0,0,1-3.156-3.21,3.15,3.15,0,1,1,3.156,3.21Zm1.912-3.233a1.924,1.924,0,1,0-3.847.047,1.924,1.924,0,1,0,3.847-.047Z",
    transform: "translate(-3.988 -4.108)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommitteSetting);
export default __webpack_public_path__ + "static/media/CommitteSetting.b829d856fd0158c0732250b54ff15a0c.svg";
export { ForwardRef as ReactComponent };